import { render, staticRenderFns } from "./AppSideBar.vue?vue&type=template&id=2adf8f65&scoped=true&"
import script from "./AppSideBar.vue?vue&type=script&lang=js&"
export * from "./AppSideBar.vue?vue&type=script&lang=js&"
import style0 from "./AppSideBar.vue?vue&type=style&index=0&id=2adf8f65&prod&lang=sass&scoped=true&"
import style1 from "./AppSideBar.vue?vue&type=style&index=1&id=2adf8f65&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adf8f65",
  null
  
)

export default component.exports